import React from 'react'
import styled from '@emotion/styled'
import { PortalArticleBlock } from '../../../models/PortalArtigoModel'

interface PortalArticleEditorOutlineProps {
  blocks: PortalArticleBlock[]
  onNavigateToBlock: (blockIndex: number) => void
  onNavigateToTopicItem: (blockIndex: number, topicItemIndex: number) => void
}

export function PortalArticleEditorOutline({
  blocks,
  onNavigateToBlock,
  onNavigateToTopicItem,
}: PortalArticleEditorOutlineProps) {
  return (
    <OutlineLayout>
      {blocks.length === 0 ? (
        <EmptyText>Nenhum bloco adicionado.</EmptyText>
      ) : (
        <OutlineList role="menu">
          {blocks.map((block, index) => (
            <li key={`${block.type}-${block.id || index}`}>
              <OutlineButton role="menuitem" type="button" onClick={() => onNavigateToBlock(index)}>
                {getBlockLabel(block)}
              </OutlineButton>
              {block.type === 'topic' && (
                <NestedList>
                  {block.items.map((item, itemIndex) =>
                    item.type === 'section' && item.role === 'subtopic' ? (
                      <li key={item.id || itemIndex}>
                        <OutlineButton
                          role="menuitem"
                          type="button"
                          onClick={() => onNavigateToTopicItem(index, itemIndex)}
                        >
                          H3: {item.section.title || 'Sem título'}
                        </OutlineButton>
                      </li>
                    ) : null
                  )}
                </NestedList>
              )}
            </li>
          ))}
        </OutlineList>
      )}
    </OutlineLayout>
  )
}

function getBlockLabel(block: PortalArticleBlock) {
  if (block.type === 'intro') return 'Introdução'
  if (block.type === 'summary') return 'Índice'
  if (block.type === 'topic') {
    const main = block.items.find((item) => item.type === 'section' && item.role === 'main')
    return main?.type === 'section' && main.section.title.trim()
      ? `Tópico: ${main.section.title.trim()}`
      : 'Tópico sem título'
  }

  return 'Bloco'
}

const OutlineLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 340px;
  max-width: calc(100vw - 48px);
  max-height: min(560px, calc(100vh - 160px));
  overflow-y: auto;
`

const OutlineList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
`

const OutlineButton = styled.button`
  width: 100%;
  border: 0;
  border-radius: 4px;
  padding: 6px 8px;
  background: transparent;
  color: #262626;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #fafafa;
  }
`

const NestedList = styled.ul`
  margin: 0 0 0 16px;
  padding: 0;
  list-style: none;
`

const EmptyText = styled.div`
  color: #8c8c8c;
`
